<template>
  <div id="umeng-push-setting" class="pb50">
    <el-tabs v-model="activeTab">
      <el-tab-pane label="推送配置" name="config">
        <el-form ref="form" size="small" :model="form" label-width="160px" v-loading="loading">
          <div class="common-form">基础开关</div>
          <el-form-item label="启用 APP 推送">
            <el-switch v-model="form.enabled" :active-value="1" :inactive-value="0" />
            <div class="form-tip">关闭后服务端不会调用推送接口（站内信仍正常）</div>
          </el-form-item>
          <!-- 暂不使用友盟，固定 uni-push
          <el-form-item label="推送服务商">
            <el-radio-group v-model="form.provider">
              <el-radio label="unipush">uni-push 2.0（推荐）</el-radio>
              <el-radio label="umeng">友盟 U-Push</el-radio>
            </el-radio-group>
            <div class="form-tip">切换后需客户端用对应 SDK 重新 register 设备标识</div>
          </el-form-item>
          -->
          <el-form-item label="异步重试">
            <el-switch v-model="form.async_push" :active-value="1" :inactive-value="0" />
          </el-form-item>
          <el-form-item label="最大重试次数">
            <el-input-number v-model="form.max_retry" :min="0" :max="10" />
          </el-form-item>

          <template>
            <div class="common-form">uni-push（uniCloud 云函数 URL 化）</div>
            <el-form-item label="云函数 URL">
              <el-input
                v-model="form.unipush.cloud_function_url"
                class="max-w460"
                placeholder="https://xxx.bspapp.com/http/..."
              />
              <div class="form-tip">在 uniCloud 控制台为推送云函数开启 URL 化后的完整地址</div>
            </el-form-item>
            <el-form-item label="请求密钥">
              <el-input
                v-model="form.unipush.request_secret"
                class="max-w460"
                show-password
                placeholder="可选，与云函数内 X-Push-Secret 校验一致"
              />
            </el-form-item>
            <el-form-item label="HTTP 超时(秒)">
              <el-input-number v-model="form.unipush.timeout" :min="3" :max="60" />
            </el-form-item>
            <el-form-item label="强制通知栏">
              <el-switch v-model="form.unipush.force_notification" />
              <div class="form-tip">透传场景下是否仍弹出系统通知（传给云函数 force_notification）</div>
            </el-form-item>
          </template>

          <!-- 友盟配置已隐藏
          <template v-else>
            ...
          </template>
          -->

          <div class="common-button-wrapper">
            <el-button type="primary" :loading="saving" @click="saveConfig">保存配置</el-button>
          </div>
        </el-form>
      </el-tab-pane>

      <el-tab-pane label="测试推送" name="test">
        <el-form size="small" label-width="120px" style="max-width: 560px;">
          <el-form-item label="用户 ID">
            <el-input v-model="testForm.user_id" placeholder="已 register 且 push_provider 与后台一致的用户" />
          </el-form-item>
          <el-form-item label="标题">
            <el-input v-model="testForm.title" />
          </el-form-item>
          <el-form-item label="内容">
            <el-input v-model="testForm.content" type="textarea" :rows="3" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" :loading="testing" @click="submitTest">发送测试</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>

      <el-tab-pane label="推送日志" name="logs">
        <div class="common-seach-wrap">
          <el-form size="small" :inline="true" :model="logSearch">
            <el-form-item label="状态">
              <el-select v-model="logSearch.status" clearable placeholder="全部" style="width: 120px;">
                <el-option label="待发送" value="0" />
                <el-option label="成功" value="1" />
                <el-option label="失败" value="2" />
                <el-option label="无效Token" value="3" />
              </el-select>
            </el-form-item>
            <el-form-item label="用户ID">
              <el-input v-model="logSearch.user_id" clearable style="width: 120px;" />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" icon="el-icon-search" @click="loadLogs(1)">查询</el-button>
            </el-form-item>
          </el-form>
        </div>
        <el-table size="small" :data="logList" v-loading="logLoading">
          <el-table-column prop="id" label="ID" width="72" />
          <el-table-column prop="user_id" label="用户" width="80" />
          <el-table-column prop="push_provider" label="服务商" width="88" />
          <el-table-column prop="platform" label="平台" width="80" />
          <el-table-column prop="message_scene" label="场景" width="140" show-overflow-tooltip />
          <el-table-column prop="title" label="标题" min-width="120" show-overflow-tooltip />
          <el-table-column label="状态" width="90">
            <template slot-scope="scope">
              {{ statusText(scope.row.status) }}
            </template>
          </el-table-column>
          <el-table-column prop="error_msg" label="错误" min-width="140" show-overflow-tooltip />
          <el-table-column prop="create_time" label="时间" width="160" />
        </el-table>
        <div class="pagination">
          <el-pagination
            background
            :current-page="logSearch.page"
            :page-size="logSearch.list_rows"
            layout="total, prev, pager, next"
            :total="logTotal"
            @current-change="loadLogs"
          />
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import UmengpushApi from '@/api/umengpush'

const defaultForm = () => ({
  enabled: 0,
  provider: 'unipush',
  production_mode: true,
  alias_type: 'USER_ID',
  async_push: 1,
  max_retry: 3,
  unipush: {
    cloud_function_url: '',
    request_secret: '',
    timeout: 10,
    force_notification: false,
  },
  android: { app_key: '', app_master_secret: '' },
  ios: { app_key: '', app_master_secret: '' },
})

export default {
  name: 'UmengPushSetting',
  data() {
    return {
      activeTab: 'config',
      loading: false,
      saving: false,
      testing: false,
      form: defaultForm(),
      testForm: {
        user_id: '',
        title: '测试推送',
        content: '这是一条来自商家后台的测试消息',
      },
      logSearch: {
        page: 1,
        list_rows: 20,
        status: '',
        user_id: '',
      },
      logList: [],
      logTotal: 0,
      logLoading: false,
    }
  },
  created() {
    this.loadConfig()
  },
  methods: {
    normalizeForm(values) {
      const v = values || {}
      const form = defaultForm()
      form.enabled = Number(v.enabled) === 1 ? 1 : 0
      form.provider = 'unipush'
      form.production_mode = v.production_mode === true || v.production_mode === 1 || v.production_mode === '1'
      form.alias_type = v.alias_type || 'USER_ID'
      form.async_push = Number(v.async_push) === 0 ? 0 : 1
      form.max_retry = Number(v.max_retry) >= 0 ? Number(v.max_retry) : 3
      form.unipush = Object.assign(form.unipush, v.unipush || {})
      form.unipush.timeout = Number(form.unipush.timeout) >= 3 ? Number(form.unipush.timeout) : 10
      form.unipush.force_notification = !!form.unipush.force_notification
      form.android = Object.assign(form.android, v.android || {})
      form.ios = Object.assign(form.ios, v.ios || {})
      return form
    },
    loadConfig() {
      this.loading = true
      UmengpushApi.getConfig()
        .then(res => {
          const values = (res.data && res.data.vars && res.data.vars.values) || {}
          this.form = this.normalizeForm(values)
        })
        .finally(() => {
          this.loading = false
        })
    },
    saveConfig() {
      this.saving = true
      UmengpushApi.saveConfig(this.form)
        .then(res => {
          if (res.code === 1) {
            this.$message.success('保存成功')
            this.loadConfig()
          }
        })
        .finally(() => {
          this.saving = false
        })
    },
    submitTest() {
      const userId = Number(this.testForm.user_id)
      if (!userId) {
        this.$message.warning('请填写用户 ID')
        return
      }
      this.testing = true
      UmengpushApi.testSend({
        user_id: userId,
        title: this.testForm.title,
        content: this.testForm.content,
      })
        .then(res => {
          if (res.code === 1) {
            this.$message.success('推送已发送')
            this.activeTab = 'logs'
            this.loadLogs(1)
          }
        })
        .finally(() => {
          this.testing = false
        })
    },
    loadLogs(page) {
      if (page) this.logSearch.page = page
      this.logLoading = true
      UmengpushApi.logs(this.logSearch)
        .then(res => {
          const list = (res.data && res.data.list) || {}
          this.logList = list.data || []
          this.logTotal = list.total || 0
        })
        .finally(() => {
          this.logLoading = false
        })
    },
    statusText(status) {
      const map = { 0: '待发送', 1: '成功', 2: '失败', 3: '无效Token' }
      return map[Number(status)] || '-'
    },
  },
  watch: {
    activeTab(val) {
      if (val === 'logs' && !this.logList.length) {
        this.loadLogs(1)
      }
    },
  },
}
</script>

<style scoped>
.form-tip {
  font-size: 12px;
  color: #909399;
  line-height: 1.5;
  margin-top: 4px;
}
.max-w460 {
  max-width: 460px;
}
.common-form {
  margin: 16px 0 12px;
  font-weight: bold;
  color: #303133;
}
</style>



// WEBPACK FOOTER //
// src/views/setting/umengpush/index.vue